import Server from '@/core/resources/Server'
import RemoteFile from '@/core/resources/RemoteFile'
import { APIResourceService } from '@/core/services/APIService'
import { buildException } from '@/core/exceptions'
export class ServerService extends APIResourceService<Server> {
  constructor() {
    super(Server)
  }

  /**
   * Lists files on a remote server
   * @param id Server id
   * @param path File path
   * @param token JWT token
   * @returns
   */
  getServerFiles(id: number, path: string, token: string): Promise<Array<RemoteFile>> {
    const param = {
      path: path
    }
    return this.client
      .get('servers/' + id + '/content', token, param)
      .then((result) => result.data as RemoteFile[])
      .catch((err) => {
        throw buildException(err)
      })
  }

  uploadFilesOnServer(id: number, path: string, data: FormData, token: string): Promise<boolean> {
    return this.client
      .post('servers/' + id + '/upload_content?path=' + path, data, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }

  mkdir(id: number, path: string, folderName: string, token: string): Promise<boolean> {
    return this.client
      .post('servers/' + id + '/mkdir?path=' + path + '&foldername=' + folderName, null, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }

  deleteOnServer(id: number, path: string, file: RemoteFile, token: string): Promise<boolean> {
    const param = {
      path: path
    }
    return this.client
      .delete('servers/' + id + '/delete_content', file, token, param)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }

  /**
   * Download a file from a remote server
   * @param token
   */
  downloadFile(id: number, file: RemoteFile, token: string): Promise<File> {
    const param = {
      path: file.path
    }
    return this.client
      .get('servers/' + id + '/download_content', token, param, 'blob')
      .then((response) => new File([response.data], file.basename, { type: response.headers['content-type'] }))
      .catch((err) => {
        throw buildException(err)
      })
  }
}
